import { useSession } from '@/contexts/LitSessionProvider';
import { SESSION_LENGTHS } from './useLitSession';
import { getMFASessionSig } from '@/lib/auth/mfa';
import { getAuthId } from '@/lib/auth/getAuthId';
export default function useMFAUtilities({
  setLoading,
  setError
} = {}) {
  const {
    clients,
    sessionLength,
    setLitSession,
    MFAInfo,
    setMFAInfo,
    PKP,
    litSession,
    currentAuthMethod
  } = useSession();
  const ToggleMFA = async (authOverride, providerValue) => {
    setLoading && setLoading(true);
    try {
      if (!(authOverride || (MFAInfo === null || MFAInfo === void 0 ? void 0 : MFAInfo.authMethod))) {
        throw new Error('No MFA auth method provided');
      }
      if (authOverride) {
        console.log('Start addMFA');
        // const litContractClient = await getLitContractClient(PKP.publicKey, litSession);
        // const permittedAuthMethods =
        //   await litContractClient.pkpPermissionsContract.read.getPermittedAuthMethods(PKP.tokenId);
        const authId = await getAuthId(authOverride, PKP, litSession);
        console.log('MFAInfoInToggle', MFAInfo, authOverride);
        // const isAuthIdPermitted = permittedAuthMethods.filter(
        //   (permittedAuthMethod) =>
        //     parseInt(permittedAuthMethod.authMethodType?.toString()) ==
        //       authOverride.authMethodType && permittedAuthMethod.id == authId
        // );
        // if (isAuthIdPermitted.length == 0) {
        //   await AddPermittedAuthMethod(PKP, litSession, authOverride, [
        //     AuthMethodScope.PersonalSign,
        //   ]);
        // }
        // const mfaActionId = await getMFAActionId(PKP, litSession);
        // const permittedActions =
        //   await litContractClient.pkpPermissionsContract.read.getPermittedActions(PKP.tokenId);
        // if (!permittedActions?.includes(mfaActionId)) {
        //   await AddPermittedAction(PKP, litSession, mfaActionId, [
        //     AuthMethodScope.SignAnything,
        //     AuthMethodScope.PersonalSign,
        //   ]);
        // }
        // if (MFAInfo?.scopes && MFAInfo?.scopes?.[2] === false) {
        //   await AddPermittedAuthMethodScope(PKP, litSession, currentAuthMethod, [
        //     AuthMethodScope.PersonalSign,
        //   ]);
        // }
        const result = await fetch('/api/auth/mfa-info', {
          method: 'POST',
          body: JSON.stringify({
            dataToSave: {
              authMethodType: authOverride.authMethodType,
              authId: authId,
              providerValue: providerValue
            }
          })
        });
        const data = await result.json();
        if (data === null || data === void 0 ? void 0 : data.mfaInfo) {
          setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
            providerValue,
            authMethod: authOverride,
            scopes: [false, true, true],
            presentMFAInfo: {
              authMethodType: data.mfaInfo.auth_method_type,
              authId: data.mfaInfo.auth_id
            }
          }));
          /* await RemovePermittedAuthMethodScope( //TODO- Remove Scope
            pkp,
            sessionSig,
            currentAuthMethod,
            AuthMethodScope.SignAnything,
          ); */
          const _MFASessionSig = await getMFASessionSig(PKP, currentAuthMethod, authOverride, clients.litNodeClient, sessionLength || SESSION_LENGTHS['1 week'], litSession);
          console.log('_MFASessionSig', _MFASessionSig);
          setLitSession(_MFASessionSig);
          setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
            MFALoggedIn: true,
            sessionSigs: _MFASessionSig
          }));
        }
        console.log('End addMFA');
      } else {
        console.log('Start removeMFA');
        setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
          authMethod: null,
          providerValue: null
        }));
        // await AddPermittedAuthMethodScope(PKP, litSession, currentAuthMethod, [
        //   AuthMethodScope.SignAnything,
        // ]);
        const result = await fetch('/api/auth/mfa-info', {
          method: 'POST',
          body: JSON.stringify({
            dataToSave: {
              authMethodType: null,
              authId: null,
              providerValue: null
            }
          })
        });
        const data = await result.json();
        console.log('remove mfa data', data);
        if (data === null || data === void 0 ? void 0 : data.mfaInfo) {
          // const mfaActionId = await getMFAActionId(PKP, litSession);
          // await RemovePermittedAction(PKP, litSession, mfaActionId);
          setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
            presentMFAInfo: null,
            sessionSigs: null
          }));
          // const sessionSigs = await getPKPSessionSig(
          //   PKP,
          //   currentAuthMethod,
          //   clients.litNodeClient,
          //   sessionLength || SESSION_LENGTHS['1 week']
          // );
          // setLitSession(sessionSigs);
          setMFAInfo(prev => Object.assign(Object.assign({}, prev), {
            MFALoggedIn: false
          }));
        }
        console.log('End removeMFA');
      }
      setError && setError(null);
      setLoading && setLoading(false);
      return {
        success: true
      };
    } catch (err) {
      console.error('[ToggleMFA]', err);
      setError && setError(err.message);
      setLoading && setLoading(false);
      return {
        success: false,
        error: err.message
      };
    } finally {
      setLoading && setLoading(false);
    }
  };
  return {
    ToggleMFA
  };
}